import { render, staticRenderFns } from "./CreateBalletClass.vue?vue&type=template&id=7a9f53f6"
import script from "./CreateBalletClass.vue?vue&type=script&lang=js"
export * from "./CreateBalletClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports